module.exports = __webpack_public_path__ + "static/media/table-chairs-1.15fb8742.jpg";